import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
const IoArrowBack = require("react-icons/io5").IoArrowBack;

const TambahNews = () => {
  const [nama, setNama] = useState("");
  const [jabatan, setJabatan] = useState("");
  const [bidang, setBidang] = useState("");
  const [image, setImage] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append("nama", nama);
    formData.append("jabatan", jabatan);
    formData.append("bidang", bidang);
    if (image) formData.append("foto", image);

    const token = document.cookie
      .split("; ")
      .find((row) => row.startsWith("token="))
      ?.split("=")[1];

    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/presiden`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      alert("Berita berhasil ditambahkan!");
    } catch (error) {
      console.error("Gagal submit:", error);
      alert("Gagal menambahkan berita.");
    } finally {
      setLoading(false);
    }
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) setImage(file);
  };

  const isFormValid = nama && image;

  return (
    <div className="max-w-3xl mx-auto mt-10 p-4 border rounded shadow-sm bg-white">
      <Link to="/dashboard/pejabat">
        <div className="flex items-center gap-3 mb-4">
          <IoArrowBack />
          <h1 className="text-xl font-bold">Tambah Data</h1>
        </div>
      </Link>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block mb-1 font-semibold">Nama</label>
          <input type="text" className="w-full border px-3 py-2 rounded" value={nama} onChange={(e) => setNama(e.target.value)} />
        </div>
        <div>
          <label className="block mb-1 font-semibold">Jabatan</label>
          <input type="text" className="w-full border px-3 py-2 rounded" value={jabatan} onChange={(e) => setJabatan(e.target.value)} />
        </div>
        <div>
          <label className="block mb-1 font-semibold">Bidang</label>
          <input type="text" className="w-full border px-3 py-2 rounded" value={bidang} onChange={(e) => setBidang(e.target.value)} />
        </div>

        <div className="mt-4">
          <label className="block mb-1 font-semibold">Gambar</label>
          <input type="file" className="w-full border px-3 py-2 rounded bg-white" onChange={handleImageChange} />
        </div>

        <button type="submit" disabled={!isFormValid || loading} className={`w-full py-2 rounded text-white mt-4 ${isFormValid && !loading ? "bg-blue-600 hover:bg-blue-700" : "bg-gray-400 cursor-not-allowed"}`}>
          {loading ? "Mengirim..." : "Tambah Data"}
        </button>
      </form>
    </div>
  );
};

export default TambahNews;
